import { Page } from '@4beefopag/4bee-fopag-core/dist/organisms';
import { Col, Modal, Row, Skeleton } from 'antd';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { MODULE_BENEFIT_ORDER } from '../../../constants/modules';
import { updateByCompany, useParameterByModule } from '../../../services/repository/benefitOrderParameterRepository';
import mostrarErro from '../../../services/util/error-handler';
import SelectFolha from '../../atoms/SelectFolha';
import BenefitOrderParametrizationForm from '../../organisms/BenefitOrderParametrizationForm';
import ErrorDisplay from '../../molecules/ErrorDisplay';
import { useUserPolicy } from '../../../user-policy';

const WrapperError = styled.div`
  margin-top: 50px;
`;

function BenefitOrderParametrization() {
  const params = useParams();
  const [selectedCompany, setSelectedCompany] = useState();
  const companyIdParam = params.id && Number(params.id);
  const { userAccount } = useUserPolicy();

  const {
    data: loadedParametrization,
    isPending,
    error: errorToGetParameter,
  } = useParameterByModule(selectedCompany && selectedCompany.id);

  const onCompaniesLoaded = (companies) => {
    if (companyIdParam && !selectedCompany) {
      const company = companies.find(({ id }) => companyIdParam === id);
      setSelectedCompany(company);
    }
  };

  const askToConfirmSave = (parametrizationDraft) => {
    let message = 'O período definido será aplicado ao mês corrente e todos os seguintes.';

    const warningDays = [29, 30, 31];
    const { startDay, endDay } = parametrizationDraft;
    if (warningDays.includes(startDay) || warningDays.includes(endDay)) {
      message =
        'Ao salvar este período ele será aplicado ao mês corrente e todos os meses seguintes, onde pode ocorrer de alguns meses não terem o dia 29, 30 ou 31.';
    }

    return new Promise((res) => {
      Modal.confirm({
        title: 'Atenção',
        content: <p>{message}</p>,
        okText: 'Prosseguir',
        cancelText: 'Fechar',
        onOk: () => res(true),
        onCancel: () => res(false),
      });
    });
  };

  const handleOnSaveClick = async (parametrizationDraft) => {
    const shouldProceed = await askToConfirmSave(parametrizationDraft);
    if (!shouldProceed) {
      return;
    }

    try {
      await updateByCompany(selectedCompany && selectedCompany.id, parametrizationDraft);
      Modal.success({
        title: 'Sucesso',
        content: <p>Parametrização salva com sucesso!</p>,
      });
    } catch (e) {
      mostrarErro(e);
    }
  };

  const render = () => {
    if (
      errorToGetParameter &&
      errorToGetParameter?.response?.status >= 400 &&
      errorToGetParameter?.response?.status < 500
    ) {
      return (
        <WrapperError>
          <ErrorDisplay
            image="https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/coop/buying-items.svg"
            title={`Opsss! Desculpe ${userAccount?.name || ''}...`}
            description={errorToGetParameter?.response?.data?.message}
          />
        </WrapperError>
      );
    }
    return (
      <BenefitOrderParametrizationForm
        onSubmitClick={handleOnSaveClick}
        parametrization={loadedParametrization}
      />
    );
  };

  return (
    <Page
      projeto="Benefícios"
      titulo="Parametrização"
      linkManual={process.env.REACT_APP_LINK_MANUAL}
    >
      <h2>Período de Lançamento de Vale</h2>

      <Row>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={7}
          xl={12}
        >
          <SelectFolha
            module={MODULE_BENEFIT_ORDER}
            folhaSelecionada={selectedCompany}
            onChange={(value) => setSelectedCompany(value)}
            onCompaniesLoaded={onCompaniesLoaded}
          />
        </Col>
      </Row>
      {selectedCompany && (
        <Skeleton
          loading={isPending}
          style={{ marginTop: 16 }}
        >
          {render()}
        </Skeleton>
      )}
    </Page>
  );
}

BenefitOrderParametrization.propTypes = {};

export default BenefitOrderParametrization;
